import {
  DetailRequestDto,
  DigitalIdDTO,
  Operation,
  DigitalIdResponseDTO,
  DocumentConsultation,
  OperationTraceDTO,
  RequestFormDTO,
  VideoSelfingDTO,
  ParticipantVSDTO,
} from './../model/requests-model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { HictoricDataReponseDTO, OperationHistoricDocumentationDTO } from '../model/requests-model';
import {
  BRAND_AUTOS,
  BRAND_CONSUMO,
  BRAND_MANGO,
  BRAND_MANGONS,
  BRAND_TARJETA,
} from '@app/@core/constants/requests.constants';
import { IneDTO } from '../model/ine-model';

@Injectable()
export class RequestsGetDataApi {
  constructor(private _http: HttpClient) {}

  postHistoric(numOperation: OperationHistoricDocumentationDTO): Observable<HictoricDataReponseDTO> {
    return this._http.post<HictoricDataReponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlHistoric,
      numOperation
    );
  }

  postOperationTraces(numOperation: any) {
    return this._http.post<OperationTraceDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlOperationTraces,
      null,
      numOperation ? { params: new HttpParams().set('numOperation', numOperation) } : undefined
    );
  }

  postDocumentation(numOperation: OperationHistoricDocumentationDTO): Observable<DocumentConsultation> {
    return this._http.post<DocumentConsultation>(
      environment.URL_BASE_REQUEST + environment.subUrlDocumentation,
      numOperation
    );
  }

  getDetailRequest(detailRequest: DetailRequestDto, brand: string): Observable<RequestFormDTO> {
    switch (brand) {
      case BRAND_CONSUMO:
        return this._http.post<RequestFormDTO>(
          environment.URL_BASE_REQUEST + environment.subUrlDetailRequestConsumo,
          detailRequest
        );
      case BRAND_AUTOS:
        return this._http.post<RequestFormDTO>(
          environment.URL_BASE_REQUEST + environment.subUrlDetailRequestAutos,
          detailRequest
        );
      case BRAND_MANGONS:
        return this._http.post<RequestFormDTO>(
          environment.URL_BASE_REQUEST + environment.subUrlDetailRequestMangoNS,
          detailRequest
        );
      case BRAND_MANGO:
        return this._http.post<RequestFormDTO>(
          environment.URL_BASE_REQUEST + environment.subUrlDetailRequestMango,
          detailRequest
        );
      case BRAND_TARJETA:
        return this._http.post<RequestFormDTO>(
          environment.URL_BASE_REQUEST + environment.subUrlDetailRequestCard,
          detailRequest
        );
      default:
        console.log('no se ha encontrado la marca');
        break;
    }
  }

  getlVideoSelfingDigitalID(digitalID: DigitalIdDTO) {
    return this._http.post<DigitalIdResponseDTO>(
      environment.URL_BASE_REQUEST +
        environment.subUrlVideoSelfingDigitalID +
        '?establishment=' +
        digitalID.establishment +
        '&financialProduct=' +
        digitalID.financialProduct,
      null
    );
  }

  getPendingVideoSelfing(videoSelfing: VideoSelfingDTO) {
    return this._http.post<IneDTO>(
      environment.URL_BASE_SIGNATURE + environment.subUrlPendingVideoSelfing,
      videoSelfing
    );
  }

  postSendSMSVideoSelfing(participantVSDTO: ParticipantVSDTO) {
    return this._http.post<any>(
      environment.URL_BASE_SIGNATURE + environment.subUrlSendSMSVideoSelfing,
      participantVSDTO
    );
  }

  sendVideoselfieLink(element: Operation): void {
    //TODO
  }
}
